import { IBaseResponseDto } from './BaseDto'
import { IWorkshop } from './DishObjDto'
import { DimensionType } from './BuffetReportDto'

export enum StatusOrder {
  Created = 'Created',
  Working = 'Working',
  FullFilled = 'FullFilled',
}

export enum OrderType {
  Regular = 'Regular',
  Buffet = 'Buffet',
}

export enum CookingStatus {
  Waiting = 'Waiting',
  Cooking = 'Cooking',
  Cook_done = 'Cook_done',
}

export interface ICurrentWeight {
  weight: number
  tare: number
  errorMsg: string
}

export interface IBuffetDimension {
  order: number
  dish: number
  millet: number
  dimensionType?: DimensionType
  orderLine?: number
  correspondentType?: number
}

export interface ICreateDish {
  sourceIdent: string
  name: string
  id: number
  workshops: IWorkshop[]
  categoryRepresent: string | null
}

export interface IOrderLineDimension {
  id: number
  photoUrl: string
  thermoPhotoUrl: string
  temperature: number
  weight: number
  dimensionDatetime: string
  quantity: number
  orderLine: number
  milletType: number
}

interface IOrderLineCookingStatus {
  id: number
  cookingStatusDatetime: string
  cookingStatus: keyof typeof CookingStatus
  orderLine: number
}

export interface IOrderLine {
  id: number
  dish: ICreateDish
  quantity: number
  orderLineDimensions: IOrderLineDimension[]
  orderLineCookingStatus: IOrderLineCookingStatus[]
  comment: string
  orderLineCookingStatuses: IOrderLineCookingStatus | null
}

export interface ITable {
  id: number
  source: number
  sourceIdent: string
  name: string
}

export interface IWaiter {
  name?: string
  email: string
  code: string
  source_ident: string
}

export interface IOrder {
  id: number
  sourceIdent: string
  sourceRepresent: string
  orderRepresent: string
  table: ITable
  orderDate: string
  orderDateStart: string | null
  orderDateEnd: string | null
  status: keyof typeof StatusOrder
  orderType: keyof typeof OrderType
  orderLines: IOrderLine[]
  waiter: IWaiter | null
  workshops: IWorkshop[]
}

export interface IOrdersResponseDto extends IBaseResponseDto {
  results: IOrder[]
}

export interface IResponseModel {
  detail: string
}

export interface IRequestTrainModel {
  batch_size?: number
  num_epochs?: number
  validate_ratio?: number
  balance_diff?: number
}
